import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Dropdown, Menu, message, Modal, } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { Link } from 'react-router-dom';
import { Icon } from '@ant-design/compatible';
import { GET_DASHBOARD_ITEMS } from '../graphql/queries';
import { DELETE_DASHBOARD_ITEM } from '../graphql/mutations';
import chart from '../utils/chart'

const styles = {
  chartContainer: () => ({
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  })
}
const DashboardItemDropdown = ({ itemId, isExporting, setIsExporting }) => {
  const [removeDashboardItem] = useMutation(DELETE_DASHBOARD_ITEM, {
    refetchQueries: [
      {
        query: GET_DASHBOARD_ITEMS,
      },
    ],
  });

  const handleExportClick = useCallback(() => {
    setIsExporting(true)
  })

  useEffect(() => {
    if (isExporting) {
      const success = chart.exportToPdf(itemId)
      if (success) message.success(`Downloaded chart ${itemId}`, 2)
      else message.error(`Error downloading chart ${itemId}`, 2)


      setIsExporting(false)
    }
  }, [isExporting])

  const dashboardItemDropdownMenu = (
    <Menu>
      <Menu.Item disabled>
        <Link to={`/explore?itemId=${itemId}`}>Edit</Link>
      </Menu.Item>
      <Menu.Item
        disabled
        onClick={() =>
          Modal.confirm({
            title: 'Are you sure you want to delete this item?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',

            onOk() {
              removeDashboardItem({
                variables: {
                  id: itemId,
                },
              });
            },
          })
        }
      >
        Delete
      </Menu.Item>
      <Menu.Item
        onClick={handleExportClick}
      >Export to PDF</Menu.Item>
    </Menu>
  );
  return (
    <>
      {isExporting ? null : <Dropdown
        overlay={dashboardItemDropdownMenu}
        placement="bottomLeft"
        trigger={['click']}
      >
        <Button shape="circle" icon={<Icon type="menu" />} />
      </Dropdown>}
    </>
  );
};

const DashboardItem = ({ itemId, children, title }) => {
  const [isExporting, setIsExporting] = useState(false)

  return (
    <Card
      title={title}
      id={itemId}
      className="dashboard-item"
      style={styles.chartContainer()}
      extra={
        <DashboardItemDropdown
          itemId={itemId}
          isExporting={isExporting}
          setIsExporting={setIsExporting}
        />
      }
    >
      <div id={`render-${itemId}`} style={{ backgroundColor: "#00000000", padding: "2px"}}>
        {children}
      </div>

    </Card >
  )
};

export default DashboardItem;
